<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item
                :to="{
                    path: '/academic_Management/academic_font_management/academic_font_management_home',
                }"
                >学术系统</el-breadcrumb-item
            >
            <el-breadcrumb-item>单轮淘汰裁判系统</el-breadcrumb-item>
            <el-breadcrumb-item>单词列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row>
          <el-col :span="12"><el-page-header @back="goBack"></el-page-header></el-col>
          <el-col :span="12" align="right"><span class="">{{ paperName }} 【{{ levelName }}】</span></el-col>
        </el-row>
        <!-- 筛选 -->
        <el-card style="margin-top: 15px">
            <el-row class="title_row">
                <el-col>
                    <span class="title_class">条件筛选</span>
                </el-col>
            </el-row>
            <el-form ref="queryFormRef" :model="queryForm" label-width="80px">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="赛季" prop="season">
                            <el-select
                                placeholder="请选择类型"
                                style="width: 100%"
                                v-model="queryForm.season"
                            >
                                <el-option
                                    v-for="item in dict_season"
                                    :key="item.dictCode"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select> </el-form-item
                    ></el-col>
                    <el-col :span="6">
                        <el-form-item label="单词" prop="spell">
                            <el-input
                                v-model="queryForm.spell"
                                placeholder="请输入"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="6">
                        <el-form-item label="组别" prop="level">
                            <el-select
                                placeholder="请选择"
                                v-model="queryForm.level"
                                disabled
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item in dict_Group"
                                    :key="item.dictCode"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="6">
                        <el-form-item label="难度" prop="difficulty">
                            <el-select
                                placeholder="请选择"
                                v-model="queryForm.difficulty"
                                style="width: 100%"
                            >
                                <el-option
                                    v-for="item in difficulty_type"
                                    :key="item.dictCode"
                                    :label="item.dictLabel"
                                    :value="item.dictValue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" align="right">
                      <el-button
                        type="primary"
                        @click="searchResult"
                        >查询</el-button
                    >
                    <el-button
                        type="primary"
                        plain
                        @click="reset"
                        >重置</el-button
                    >
                    </el-col>
                </el-row>
            </el-form>
            <el-row :gutter="20" type="flex" justify="end">
                <el-col :span="2">
                </el-col>
                <el-col :span="2">
                </el-col>
            </el-row>
        </el-card>
        <!-- 列表 -->
        <el-card style="margin-top: 15px">
            <el-row class="title_row">
                <el-col :span="5">
                    <span class="title_class">单词管理</span>
                </el-col>
                <el-col :span="19" style="text-align: right">
                    <el-button
                        type="warning"
                        size="small"
                        plain
                        @click="setSortFn"
                        icon="el-icon-sort"
                        >一键乱序</el-button
                    >
                    <el-button
                        type="primary"
                        size="small"
                        plain
                        @click="importWordExcelDialogVisible = true"
                        icon="el-icon-upload2"
                        >批量导入</el-button
                    >
                    <el-button
                        type="primary"
                        size="small"
                        plain
                        @click="downloadInfoList"
                        icon="el-icon-download"
                        >批量导出</el-button
                    >
                    <el-button
                        type="success"
                        size="small"
                        @click="showChooseDialog('add')"
                        >词库选词</el-button
                    >
                    <el-button
                        type="primary"
                        size="small"
                        @click="editDistrictMessage('add')"
                        >单项新增</el-button
                    >
                    <el-button
                        type="danger"
                        size="small"
                        @click="emptyWordExcelDialogVisible = true"
                        >清空单词</el-button
                    >
                </el-col>
            </el-row>
            <el-table
                header-cell-class-name="tableHeaderStyle"
                :data="dataList"
                border
                stripe
            >
                <el-table-column label="序号" type="index"></el-table-column>
                <el-table-column label="顺序" prop="sort" width="50"></el-table-column>
                <el-table-column label="单词" prop="spell" width="200">
                    <template slot-scope="scope">
                        <!-- <el-link
                            style="color: #409eff"
                            @click="handleToWordVoice(scope.row.purl)"
                            >{{ scope.row.spell }}</el-link
                        > -->
                        <div class="spell">{{ scope.row.spell }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="词性" prop="partSpeech" width="80">
                    <!-- <template slot-scope="scope">
                        <el-link
                            style="color: #409eff"
                            @click="handleToWordVoice(scope.row.partUrl)"
                            >{{ scope.row.partSpeech }}</el-link
                        >
                    </template> -->
                </el-table-column>
                <el-table-column
                    label="定义"
                    prop="def"
                >
                <!-- :show-overflow-tooltip="true" -->
                    <!-- <template slot-scope="scope">
                        <el-link
                            style="color: #409eff"
                            @click="handleToWordVoice(scope.row.durl)"
                            >{{ scope.row.def }}</el-link
                        >
                    </template> -->
                    </el-table-column
                >
                <el-table-column
                    label="例句"
                    prop="exp"
                >
                <!-- :show-overflow-tooltip="true" -->
                    <!-- <template slot-scope="scope">
                        <el-link
                            style="color: #409eff"
                            @click="handleToWordVoice(scope.row.eurl)"
                            >{{ scope.row.exp }}</el-link
                        >
                    </template> -->
                    </el-table-column
                >
                <el-table-column label="音标" prop="phonetic" width="100">
                </el-table-column>
                <el-table-column
                    label="组别" width="150"
                    prop="enrollmentLevel"
                    :formatter="groupFormatter"
                ></el-table-column>
                <!-- <el-table-column
                    label="难度"
                    prop="difficulty"
                    :formatter="difficultyFormatter"
                ></el-table-column> -->
                <!-- <el-table-column
                    label="入库时间"
                    prop="indataAt"
                ></el-table-column> -->
                <el-table-column label="操作" width="140px">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            size="mini"
                            @click="editDistrictMessage('edit', scope.row)"
                            >编辑</el-button
                        >
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            size="small"
                            style="color: #f56c6c"
                            @click="deleteDialog(scope.row.id)"
                            >删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryForm.pageNum"
                :page-sizes="[10, 20, 40, 80]"
                :page-size="queryForm.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </el-card>
        <audio ref="audioPlayer" @ended="overAudio"></audio>
        <!-- 批量导入英文单词的Dialog -->
        <el-dialog
            title="批量导入数据"
            :visible.sync="importWordExcelDialogVisible"
            width="500px"
            @close="importWordExcelDialogClose"
        >
          <div class="panel">
            <div>
              <div class="title">新增导入</div>
              <div class="desc">下载Excel模板，批量新增单词。</div>
            </div>
            <el-form
                :model="importQueryForm"
                label-width="100px"
                ref="importWordInfoFormRef"
                :rules="importWordInfoRules"
                style="width: 100%"
            >
                <el-form-item label="组别" prop="level">
                    <el-select v-model="importQueryForm.level" disabled>
                        <el-option
                            v-for="item in dict_Group"
                            :key="item.dictCode"
                            :label="item.dictLabel"
                            :value="item.dictValue"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-upload
                    :action="importWordExcel.uploadUrl"
                    ref="importWordExcelRef"
                    :data="importQueryForm"
                    :headers="importWordExcel.headerObj"
                    :on-progress="importWordExcelProgress"
                    :on-success="importWordExcelSuccess"
                    :on-error="importWordExcelError"
                    :on-exceed="importWordExcelExceed"
                    :on-change="onChangeLoad"
                    :limit="1"
                    :auto-upload="false"
                >
                    <el-button slot="trigger" size="small" type="primary"
                        >选取文件</el-button
                    >
                    <el-button
                        style="margin-left: 10px"
                        type="warning"
                        plain
                        size="small"
                        @click="downloadWordExcelTemplate"
                        >下载模版</el-button
                    >
                    <el-button
                        style="margin-left: 10px"
                        size="small"
                        type="success"
                        @click="uploadWordExcel"
                        >确认上传</el-button
                    >
                </el-upload>
            </span>
          </div>
          <div class="panel">
            <div>
              <div class="title">修改导入</div>
              <div class="desc">下载已导入的单词数据，修改文件内容（如定义、例句等），重新上传覆盖原有数据。</div>
              <span slot="footer" class="dialog-footer">
                <el-upload
                    :action="importWordExcel.uploadUrl2"
                    ref="importWordExcelRef2"
                    :data="importQueryForm2"
                    :headers="importWordExcel.headerObj"
                    :on-progress="importWordExcelProgress2"
                    :on-success="importWordExcelSuccess2"
                    :on-error="importWordExcelError2"
                    :on-exceed="importWordExcelExceed2"
                    :on-change="onChangeLoad2"
                    :limit="1"
                    :auto-upload="false"
                >
                    <el-button slot="trigger" size="small" type="primary"
                        >选取文件</el-button
                    >
                    <el-button
                        style="margin-left: 10px"
                        type="warning"
                        size="small"
                        @click="downloadInfoList"
                        >批量导出</el-button
                    >
                    <el-button
                        style="margin-left: 10px"
                        size="small"
                        type="success"
                        @click="uploadWordExcel2"
                        >确认上传</el-button
                    >
                </el-upload>
            </span>
            </div>
          </div>
        </el-dialog>
        <!-- 清空组别单词的Dialog -->
        <el-dialog
            title="清空单词"
            :visible.sync="emptyWordExcelDialogVisible"
            width="30%"
            @close="emptyWordExcelDialogClose"
        >
            <el-form
                :model="importQueryForm"
                label-width="100px"
                ref="emptyWordInfoFormRef"
                :rules="importWordInfoRules"
                style="width: 100%"
            >
                <el-form-item label="组别" prop="level">
                    <el-select v-model="importQueryForm.level" disabled>
                        <el-option
                            v-for="item in dict_Group"
                            :key="item.dictCode"
                            :label="item.dictLabel"
                            :value="item.dictValue"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="难度" prop="difficulty">
                    <el-select
                        placeholder="请选择"
                        v-model="importQueryForm.difficulty"
                    >
                        <el-option
                            v-for="item in difficulty_type"
                            :key="item.dictCode"
                            :label="item.dictLabel"
                            :value="item.dictValue"
                        ></el-option>
                    </el-select>
                </el-form-item> -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="emptyWordExcelDialogVisible = false"
                    >取 消</el-button
                >
                <el-button type="primary" @click="saveEmptyQueryClick"
                    >保 存</el-button
                >
            </span>
        </el-dialog>
        <wordDetaiEdit
            :paperId="queryForm.paperId"
            :show="editCharactersDialogVisible"
            :editWordDetailForm="editWordDetailForm"
            @close="closeFn"
        ></wordDetaiEdit>
        <el-dialog
          :title="paperName +'【' + levelName +'】'"
          :visible.sync="chooseDialog"
          :width="width">
          <div v-if="step === 1">
            <div class="choose-title">您希望如何出题？</div>
            <div>
              <div class="choose-box" @click="chooseFn(0)">
                <div class="choose-box-title">系统抽词</div>
                <div class="desc">系统根据筛选项抽取符合要求的单词。</div>
              </div>
              <div class="choose-box" @click="chooseFn(1)">
                <div class="choose-box-title">手动挑词</div>
                <div class="desc">在指定词库中选择单词，可多选。</div>
              </div>
            </div>
          </div>
          <div v-else-if="step === 2">
            <div v-if="form === 0">
              <div class="step-title">系统抽词<span @click="chooseFn(1)">切换为手动挑词</span></div>
              <el-tabs v-model="activeType" @tab-click="handleClick">
                <el-tab-pane v-for="(item, index) in lexiconType" :key="index" :label="item.label" :name="item.id"></el-tab-pane>
              </el-tabs>
              <el-form :model="newForm" label-width="80px">
                <el-form-item label="词库" prop="thesaurusIdList">
                  <el-select
                      placeholder="请选择类型"
                      style="width: 100%"
                      v-model="thesaurusIdList"
                  >
                      <el-option
                          v-for="item in lexiconList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                      ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="音节" prop="syllables">
                  <el-select
                      placeholder="请选择类型"
                      style="width: 100%"
                      v-model="newForm.syllables"
                  >
                      <el-option label="单音节" :value="1"></el-option>
                      <el-option label="多音节" :value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="单词长度">
                  <el-input-number class="small-input" size="small" v-model="newForm.numberofBeginLetters" :min="1"></el-input-number>
                  ~
                  <el-input-number class="small-input" size="small" v-model="newForm.numberofEndLetters" :min="1"></el-input-number>
                </el-form-item>
                <el-form-item label="词频长度" v-if="activeType === '1'">
                  <el-input-number class="small-input" size="small" v-model="newForm.rankBegin" :min="1"></el-input-number>
                  ~
                  <el-input-number class="small-input" size="small" v-model="newForm.rankEnd" :min="1"></el-input-number>
                </el-form-item>
                <el-form-item label="单词数量" prop="num">
                  <el-input-number v-model="newForm.num" :min="1"></el-input-number>
                </el-form-item>
                <el-form-item label="单词" prop="spell">
                  <el-input v-model="newForm.spell"></el-input>
                </el-form-item>
              </el-form>
              <div style="text-align: center;">
                <el-button type="primary" @click="submit1Fn('click')">开始抽词</el-button>
              </div>
            </div>
            <div v-if="form === 1">
              <div class="step-title">手动挑词<span @click="chooseFn(0)">切换为系统抽词</span></div>
              <el-tabs v-model="activeType" @tab-click="handleClick">
                <el-tab-pane v-for="(item, index) in lexiconType" :key="index" :label="item.label" :name="item.id"></el-tab-pane>
              </el-tabs>
              <el-row>
                <el-col :span="3">
                  <div class="left-tab-box">
                    <div class="left-tab" :class="activeId === item.id ? 'active' : ''" v-for="item in lexiconList" :key="item.id" @click="changeLexiconFn(item)">{{ formatName(item.name) }}</div>
                  </div>
                </el-col>
                <el-col :span="21">
                  <div class="table-box">
                    <el-row class="tips">
                      <el-col :span="16">选择本页单词后，需要点击保存。切换到下一页时，本页已选的单词不会被保留。</el-col>
                      <el-col :span="8" align="right">
                        <el-button type="success" @click="submit2Fn">保存本页已选单词</el-button>
                      </el-col>
                    </el-row>
                    <div class="search-box">
                      <el-form ref="queryWordFormRef" :model="queryWordForm" label-width="80px">
                        <el-row>
                          <el-col :span="8" style="height: 44px;">
                            <el-form-item label="音节" prop="syllables">
                              <el-select size="small"
                                  placeholder="请选择类型"
                                  style="width: 100%"
                                  v-model="queryWordForm.syllables"
                              >
                                  <el-option label="单音节" :value="1"></el-option>
                                  <el-option label="多音节" :value="2"></el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12" style="height: 44px;">
                            <el-form-item label="单词长度">
                              <el-input-number class="big-input" size="small" v-model="queryWordForm.numberofBeginLetters" :min="1"></el-input-number>
                              ~
                              <el-input-number class="big-input" size="small" v-model="queryWordForm.numberofEndLetters" :min="1"></el-input-number>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8" style="height: 50px;">
                            <el-form-item label="单词" prop="spell">
                              <el-input size="small" v-model="queryWordForm.spell"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12" style="height: 50px;" v-if="activeType === '1'">
                            <el-form-item label="词频长度">
                              <el-input-number class="big-input" size="small" v-model="queryWordForm.rankBegin" :min="1"></el-input-number>
                              ~
                              <el-input-number class="big-input" size="small" v-model="queryWordForm.rankEnd" :min="1"></el-input-number>
                            </el-form-item>
                          </el-col>
                          <el-col :span="activeType === '1' ? 4 : 15" style="height: 50px;" :align="activeType === '1' ? 'left' : 'right'">
                              <el-button type="primary" size="small" style="margin-top: 5px;" @click="getWordList">查询</el-button>
                              <el-button type="primary" size="small" plain @click="resetWordList">重置</el-button>
                          </el-col>
                        </el-row>
                      </el-form>
                    </div>
                    <div class="table-scroll">
                      <el-table
                          header-cell-class-name="tableHeaderStyle"
                          :data="wordList"
                          border
                          stripe
                          @selection-change="handleSelectionChange"
                      >
                        <el-table-column
                        type="selection"
                        width="55"></el-table-column>
                        <el-table-column label="序号" type="index"></el-table-column>
                        <el-table-column label="单词" prop="spell">
                          <template slot-scope="scope">
                            <div class="spell">{{ scope.row.spell }}</div>
                          </template>
                        </el-table-column>
                        <el-table-column label="定义" prop="def" width="200"></el-table-column>
                        <el-table-column label="例句" prop="exp" width="200"></el-table-column>
                        <el-table-column label="词性" prop="partofSpeech"></el-table-column>
                        <el-table-column label="音标" prop="websterPhoneticAlphabet"></el-table-column>
                        <el-table-column label="词频" prop="rank"></el-table-column>
                        <el-table-column label="音节" prop="syllables" :formatter="syllablesFormat"></el-table-column>
                        <el-table-column label="词源" prop="language_origin" v-if="activeType === '2'"></el-table-column>
                      </el-table>
                      <!-- 分页 -->
                      <div style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange2"
                            @current-change="handleCurrentChange2"
                            :current-page="queryWordForm.pageNum"
                            :page-sizes="[10, 20, 40, 80]"
                            :page-size="queryWordForm.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="wordTotal"
                        >
                        </el-pagination>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>

          </div>
          </el-dialog>
    </div>
</template>

<script>
import { getCityQuestionWordList, deleteCityQuestionWord, emptyCityQuestionWord, cityQuestionWord } from '@/http/api'
import wordDetaiEdit from './components/city_word_edit'
export default {
  components: {
    wordDetaiEdit
  },
  data () {
    return {
      dataList: [],
      editWordDetailForm: {
        spell: '',
        purl: '',
        def: '',
        durl: '',
        exp: '',
        eurl: '',
        phonetic: '',
        difficulty: null,
        level: Number(this.$route.query.level),
        partSpeech: ''
      },
      difficulty_type: this.$userInfo.difficulty_type(),
      importWordExcel: {
        uploadUrl: this.$env.baseIP + 'cityQuestionWord/importExcel',
        uploadUrl2: this.$env.baseIP + 'cityQuestionWord/importUpdateExcel',
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        }
      },
      isUploadFile: false, // 是否已选择上传文件
      importQueryForm: {
        raceSchedule: '4',
        paperId: this.$route.query.paperId,
        level: Number(this.$route.query.level)
      },
      importQueryForm2: {
        paperId: this.$route.query.paperId
      },
      importWordInfoRules: {
        level: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      editCharactersDialogVisible: false,
      emptyWordExcelDialogVisible: false,
      importWordExcelDialogVisible: false,
      dict_season: this.$userInfo.getDataList(this, 't_season', this.$store.state.flag).then(value => { this.dict_season = value }),
      dict_Group: this.$userInfo.dict_group(),
      total: 0,
      queryForm: {
        season: this.$chnEngStatusCode.defaultSeason,
        paperId: this.$route.query.paperId,
        // raceSchedule: '4',
        spell: '',
        // level: Number(this.$route.query.level),
        pageNum: 1,
        pageSize: 10
      },
      chooseDialog: false,
      step: 1,
      form: 0,
      width: '500px',
      activeType: '1',
      lexiconType: [
        { id: '1', label: '组别词库' },
        { id: '2', label: '词源词库' },
        { id: '3', label: '挑战词库' }
      ],
      thesaurusIdList: '',
      newForm: {
        paperId: '',
        thesaurusIdList: [],
        syllables: '',
        spell: '',
        rankBegin: 1,
        rankEnd: 50000,
        numberofBeginLetters: 1,
        numberofEndLetters: 5,
        num: 10,
        continueSave: false
      },
      lexiconList: [],
      value1: [0, 10],
      activeId: '',
      queryWordForm: {
        paperId: this.$route.query.paperId,
        pageNum: 1,
        pageSize: 30,
        thesaurusIdList: [],
        syllables: '',
        spell: '',
        rankBegin: 1,
        rankEnd: 50000,
        numberofBeginLetters: 1,
        numberofEndLetters: 5
      },
      wordList: [],
      wordTotal: 0,
      multipleSelection: [],
      paperName: '',
      levelName: ''
    }
  },
  created () {
    this.paperName = this.$route.query.paperName
    this.levelName = this.dict_Group.find(item => item.dictValue === Number(this.$route.query.level)).dictLabel
    this.searchResult()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    searchResult () {
      getCityQuestionWordList(this.queryForm).then((res) => {
        this.dataList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 单词点击事件
    handleToWordVoice (voiceUrl) {
      this.$refs.audioPlayer.src = voiceUrl
      this.$refs.audioPlayer.play()
    },
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.queryForm.pageNum = 1
      this.queryForm.pageSize = 10
      this.searchResult()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.searchResult()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.searchResult()
    },
    // 一键乱序
    setSortFn () {
      this.$confirm('单词顺序将随机打乱，确认操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.$http.post('cityQuestionWord/oneClickDisorder', { id: this.queryForm.paperId }).then(res => {
          if (res.code === 200) {
            this.reset()
          }
        })
      })
    },
    // 批量导出
    downloadInfoList () {
      const downLoadUrl = this.$env.baseIP + 'cityQuestionWord/exportExcel'
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, '', this.queryForm)
    },
    // 下载字库模板
    async downloadWordExcelTemplate () {
      var downLoadUrl = this.$env.baseIP + 'cityQuestionWord/downloadExcel'
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, '', {})
    },
    // 上传文件超时
    importWordExcelExceed (files, fileList) {
      console.log('fileList', files, fileList)
      this.$set(fileList[0], 'raw', files[0])
      this.$set(fileList[0], 'name', files[0].name)
      this.$refs.importWordExcelRef.clearFiles()// 清除文件
      this.$refs.importWordExcelRef.handleStart(files[0])// 选择文件后的赋值方法
    },
    // 上传文件加载中
    importWordExcelProgress () {
    },
    // 上传文件成功回调
    importWordExcelSuccess (res) {
      console.log('importWordExcelSuccess', res)
      this.$curUtils.closeLoading(this)
      this.isUploadFile = false
      if (res.code !== 200) {
        this.$refs.importWordExcelRef.clearFiles()// 清除文件
        return this.$alert('请修改后再上传，失败原因:' + res.msg, '上传失败', {
          confirmButtonText: '确定',
          type: 'warning',
          dangerouslyUseHTMLString: true
        })
      }
      this.$message.success('上传内容成功')
      this.importWordExcelDialogVisible = false
      this.searchResult()
      this.$refs.importWordExcelRef.clearFiles()// 清除文件
    },
    // 上传文件失败回调
    importWordExcelError (error) {
      console.log('importWordExcelError', error)
      this.$curUtils.closeLoading(this)
      this.$message.error('上次文件失败')
    },
    // 监听上传文件弹窗关闭事件
    importWordExcelDialogClose () {
      this.isUploadFile = false
    },
    // 上传前判断文件是否为空
    uploadWordExcel () {
      console.log(this.isUploadFile)
      if (this.isUploadFile) {
        this.$refs.importWordExcelRef.submit()
      } else {
        this.$message.error('请先选择要上传的文件')
      }
    },
    // 监听上传文件变化
    onChangeLoad (files, fileList) {
      if (fileList.length > 0) {
        this.isUploadFile = true
      }
    },
    emptyWordExcelDialogClose () {
      this.$refs.emptyWordInfoFormRef.resetFields()
    },

    // 上传文件超时
    importWordExcelExceed2 (files, fileList) {
      console.log('fileList', files, fileList)
      this.$set(fileList[0], 'raw', files[0])
      this.$set(fileList[0], 'name', files[0].name)
      this.$refs.importWordExcelRef2.clearFiles()// 清除文件
      this.$refs.importWordExcelRef2.handleStart(files[0])// 选择文件后的赋值方法
    },
    // 上传文件加载中
    importWordExcelProgress2 () {
    },
    // 上传文件成功回调
    importWordExcelSuccess2 (res) {
      console.log('importWordExcelSuccess', res)
      this.$curUtils.closeLoading(this)
      this.isUploadFile2 = false
      if (res.code !== 200) {
        this.$refs.importWordExcelRef2.clearFiles()// 清除文件
        return this.$alert('请修改后再上传，失败原因:' + res.msg, '上传失败', {
          confirmButtonText: '确定',
          type: 'warning',
          dangerouslyUseHTMLString: true
        })
      }
      this.$message.success('上传内容成功')
      this.importWordExcelDialogVisible = false
      this.searchResult()
      this.$refs.importWordExcelRef2.clearFiles()// 清除文件
    },
    // 上传文件失败回调
    importWordExcelError2 (error) {
      console.log('importWordExcelError', error)
      this.$curUtils.closeLoading(this)
      this.$message.error('上次文件失败')
    },
    // 监听上传文件弹窗关闭事件
    importWordExcelDialogClose2 () {
      this.isUploadFile = false
    },
    // 上传前判断文件是否为空
    uploadWordExcel2 () {
      console.log(this.isUploadFile2)
      if (this.isUploadFile2) {
        this.$refs.importWordExcelRef2.submit()
      } else {
        this.$message.error('请先选择要上传的文件')
      }
    },
    // 监听上传文件变化
    onChangeLoad2 (files, fileList) {
      if (fileList.length > 0) {
        this.isUploadFile2 = true
      }
    },
    emptyWordExcelDialogClose2 () {
      this.$refs.emptyWordInfoFormRef2.resetFields()
    },
    // 删除
    deleteDialog (rowId) {
      this.$confirm('是否确认删除该单词?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        deleteCityQuestionWord({ id: rowId }).then((res) => {
          this.searchResult()
        }).catch((err) => {
          console.log('返回的err', err)
        })
      })
    },
    // 清空本组别单词
    saveEmptyQueryClick () {
      this.$confirm('是否确认删除该组别下所有单词?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        emptyCityQuestionWord(this.importQueryForm).then((res) => {
          this.searchResult()
        }).catch((err) => {
          console.log('返回的err', err)
        })
      })
    },
    // 修改单词
    editDistrictMessage (type, rowData) {
      console.log('type', type)
      console.log('rowData', rowData)
      if (type === 'edit') {
        cityQuestionWord({ id: rowData.id }).then((res) => {
          this.editWordDetailForm = res.data
        }).catch((err) => {
          console.log('返回的err', err)
        })
      }
      this.editCharactersDialogVisible = true
    },
    closeFn () {
      this.editCharactersDialogVisible = false
      this.searchResult()
    },
    overAudio () {
    },
    groupFormatter (data) {
      var temp = '未设置'
      for (const key in this.dict_Group) {
        if (Object.hasOwnProperty.call(this.dict_Group, key)) {
          const element = this.dict_Group[key]
          if (element.dictValue === data.level) {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    difficultyFormatter (data) {
      var temp = '未设置'
      for (const key in this.difficulty_type) {
        if (Object.hasOwnProperty.call(this.difficulty_type, key)) {
          const element = this.difficulty_type[key]
          if (element.dictValue === data.difficulty) {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    formatName (str) {
      return str.split('(')[0]
    },
    showChooseDialog () {
      this.chooseDialog = true
      this.step = 1
      this.form = 0
      this.width = '500px'
      this.newForm.paperId = this.queryForm.paperId
    },
    chooseFn (type) {
      this.form = type
      this.step = 2
      this.width = type === 0 ? '500px' : '1100px'
      this.activeType = '1'
      this.getLexiconList()
    },
    getLexiconList () {
      const url = this.activeType === '1' ? 'cityQuestionWord/spbcnWordThesaurusList' : this.activeType === '2' ? 'cityQuestionWord/spbcnOriginWordThesaurusList' : this.activeType === '3' ? 'cityQuestionWord/spbcnChallengeWordThesaurusList' : ''
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          this.lexiconList = res.data
          if (this.form === 1) {
            this.activeId = res.data[0].id
            this.getWordList()
          }
        }
      })
    },
    getWordList () {
      this.queryWordForm.thesaurusIdList = [this.activeId]
      if (this.activeType !== '1') {
        delete this.queryWordForm.rankBegin
        delete this.queryWordForm.rankEnd
      }
      this.$http.get('cityQuestionWord/spbcnWordList', { params: this.queryWordForm }).then(res => {
        if (res.code === 200) {
          this.wordList = res.data.list
          this.wordTotal = res.data.total
        }
      })
    },
    handleSizeChange2 (newSize) {
      this.queryWordForm.pageSize = newSize
      this.getWordList()
    },
    handleCurrentChange2 (newCurPage) {
      this.queryWordForm.pageNum = newCurPage
      this.getWordList()
    },
    resetWordList () {
      this.$refs.queryWordFormRef.resetFields()
      this.queryWordForm.pageNum = 1
      this.queryWordForm.pageSize = 10
      if (this.activeType === '1') {
        this.queryWordForm.rankBegin = 1
        this.queryWordForm.rankEnd = 50000
      }
      this.getWordList()
    },
    changeLexiconFn (item) {
      this.activeId = item.id
      this.getWordList()
    },
    handleClick () {
      this.newForm.thesaurusIdList = ''
      this.getLexiconList()
      if (this.activeType === '1') {
        if (this.form === 0) {
          this.newForm.rankBegin = 1
          this.newForm.rankEnd = 50000
        } else if (this.form === 1) {
          this.queryWordForm.rankBegin = 1
          this.queryWordForm.rankEnd = 50000
        }
      }
    },
    submit1Fn (type) {
      if (!this.thesaurusIdList) {
        return this.$message.warning('请选择词库')
      }
      if (this.newForm.numberofBeginLetters > this.newForm.numberofEndLetters) {
        return this.$message.warning('单词长度请按从小到大数字输入')
      }
      if (this.activeType === '1') {
        if (this.newForm.rankBegin > this.newForm.rankEnd) {
          return this.$message.warning('词频长度请按从小到大数字输入')
        }
      }
      if (!this.newForm.num) {
        return this.$message.warning('请输入单词数量')
      }
      if (type === 'click') {
        this.newForm.continueSave = false
      } else {
        this.newForm.continueSave = true
      }
      this.newForm.thesaurusIdList = [this.thesaurusIdList]

      if (this.activeType !== '1') {
        delete this.newForm.rankBegin
        delete this.newForm.rankEnd
      }

      this.$http.post('cityQuestionWord/createSpbcnWordByThesaurus', this.newForm).then(res => {
        if (res.code === 200) {
          this.chooseDialog = false
          this.searchResult()
        } else if (res.code === 10001) {
          this.$confirm(res.msg + '，是否使用？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit1Fn()
          }).catch(() => {
          })
        }
      })
    },
    syllablesFormat (data) {
      return data.syllables === 1 ? '单音节' : data.syllables === 2 ? '多音节' : ''
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val.map(item => item.id)
    },
    submit2Fn () {
      this.$http.post('cityQuestionWord/createSpbcnWord', { paperId: this.queryForm.paperId, ids: this.multipleSelection }).then(res => {
        if (res.code === 200) {
          this.resetWordList()
          this.searchResult()
        }
      })
    }
  }
}
</script>

<style lang="less">
.choose-title{
  font-size: 14px;
  color: #000;
  font-weight: bold;
  margin-bottom: 20px;
}
.choose-box{
  border: 1px solid #409EFF;
  color: #409EFF;
  padding: 12px 24px;
  margin-bottom: 20px;
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
  .choose-box-title{
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 6px;
  }
  .desc{
    font-size: 12px;
    color: #909399;
  }
  &:hover{
    background-color: #ECF5FF;
  }
}
.step-title{
  color: #000;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 6px;
  span{
    color: #909399;
    font-weight: normal;
    font-size: 12px;
    margin-left: 10px;
    cursor: pointer;
    &:hover{
      color: #409EFF;
    }
  }
}
.small-input{
  width: 140px;
}
.big-input{
  width: 160px;
}
.left-tab-box{
  border-right: 2px solid #E4E7ED;
  padding-right: 10px;
}
.left-tab{
  font-size: 12px;
  color: rgb(64, 158, 255);
  // background: rgb(236, 245, 255);
  border: 1px solid rgb(179, 216, 255);
  border-radius: 4px;
  margin-bottom: 10px;
  padding: 6px 12px;
  overflow-wrap: break-word;
  word-break: normal;
  cursor: pointer;
  &.active{
    color: #fff;
    background: rgb(64, 158, 255);
    border-color:rgb(64, 158, 255);
  }
}
.search-box{
  background-color: #eff6fe;
  padding: 10px 0 0;
}
.table-box{
  margin-left: 10px;
}
.spell{
  color: #409EFF;
  font-size: 14px;
  font-weight: bold;
}
.table-scroll{
  height: calc(100vh - 300px);
  overflow-y: auto;
}
.tips{
  line-height: 36px;
  margin-bottom: 10px;
  color: #000;
  font-size: 14px;
  font-weight: bold;
}

.panel{
  border: 1px dashed #b3d8ff;
  border-radius: 10px;
  padding: 12px 20px;
  background-color: #ecf5ff;
  margin-bottom: 20px;
  .title{
    font-size: 16px;
    color: #000;
    font-weight: bold;
    margin-bottom: 4px;
  }
  .desc{
    font-size: 12px;
    color: #909399;
    margin-bottom: 20px;
  }
}
.dialog-footer{
  text-align: center;
}
</style>
